import type { ReactNode } from 'react';

interface Props {
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({ title, description, action }: Props) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-10 text-center">
      <svg width="112" height="72" viewBox="0 0 112 72" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect x="8" y="14" width="96" height="44" rx="8" fill="#F1F5F9" />
        <rect x="20" y="24" width="62" height="6" rx="3" fill="#E2E8F0" />
        <rect x="20" y="36" width="44" height="4" rx="2" fill="#E2E8F0" />
        <rect x="20" y="46" width="36" height="4" rx="2" fill="#E2E8F0" />
        <circle cx="92" cy="50" r="12" fill="#2563EB" />
        <path d="M86 50l4 4 8-8" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      <p className="mt-4 font-display text-base font-semibold text-slate-900">{title}</p>
      {description ? <p className="mt-1 text-sm text-slate-500">{description}</p> : null}
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  );
}
